import { Helmet } from "react-helmet";
import classes from "../../../css/styles.module.scss";
import { Link } from "react-router-dom";

const Products = () => {
  return (
    <div>
      <Helmet>
        <title>Backend Helpers Limited | Productos</title>
      </Helmet>

      <section id="projects" className={`${classes['container-s']} ${classes.projects}`}>

        {/* 🧠 Eco-Rolling AI */}
        <div className={`${classes['project-card-border']} ${classes['mr-2']}`}>
          <div className={classes['project-card']}>
            <h2 className={classes['project-card-title']}>
              Eco-Rolling AI: <br /> Inteligencia Artificial <br /> para turismo
            </h2>
            <button type="button" className={classes['project-btn']}>
              <Link to="/es/products/eco-rolling-ai">Ver más</Link>
            </button>
          </div>
        </div>

        {/* 🧩 Academia DevOps y Full Stack */}
        <div className={`${classes['project-card-border']} ${classes['mr-2']}`}>
          <div className={classes['project-card']}>
            <h2 className={classes['project-card-title']}>
              DevOps y <br /> Full Stack <br /> Academia
            </h2>
            <button type="button" className={classes['project-btn']}>
              <Link to="/es/products/academy">Ver más</Link>
            </button>
          </div>
        </div>

      </section>

      <section id="projects2" className={`${classes['container-s']} ${classes.projects}`}>

        {/* ☁️ Computación en la nube */}
        <div className={`${classes['project-card-border']} ${classes['mr-2']}`}>
          <div className={classes['project-card']}>
            <h2 className={classes['project-card-title']}>
              Computación en la nube <br /> Transformación Digital
            </h2>
            <button type="button" className={classes['project-btn']}>
              <Link to="/es/products/step-forward-digital">Ver más</Link>
            </button>
          </div>
        </div>

      </section>
    </div>
  );
};

export default Products;
